import { useEffect } from "react"
import { uniqueId } from "library/database/split-id.mjs"
import { isEnabled } from "lib/@components/feature"
import { getRegisterTypeId } from "routes/asset-register/plugins/asset-mapping/server/get-register-type-id.mjs"
import { recordMappingFeedback } from "routes/asset-register/plugins/asset-mapping/plugins/ai-mapping-feedback/controller/record-mapping-feedback"
import { FEATURE_FLAG_AI_MAPPING_FEEDBACK } from "routes/asset-register/plugins/asset-mapping/plugins/ai-mapping-feedback/feature-flag-ai-mapping-feedback"

const capturedSignatures = new Map()

export function useCaptureSuggestionSnapshot(register, entry, schedules, open) {
    useEffect(captureSnapshot, [
        register?.id,
        register?.mappingRunId,
        entry?.name,
        entry?.feedbackAttemptId,
        schedules,
        open,
    ])

    function captureSnapshot() {
        if (!open) return
        if (!isEnabled(FEATURE_FLAG_AI_MAPPING_FEEDBACK)) return

        const runId = register?.mappingRunId
        const feedbackAttemptId = entry?.feedbackAttemptId
        if ((!feedbackAttemptId && !runId) || !entry?.name || !schedules?.length) return

        const assetTypeId = getRegisterTypeId(register.id, entry.name)
        const viewedScheduleIds = schedules.map(toScheduleId)
        const signature = `${feedbackAttemptId ?? runId}:${viewedScheduleIds.join(",")}`
        if (capturedSignatures.get(assetTypeId) === signature) return

        capturedSignatures.set(assetTypeId, signature)

        recordMappingFeedback({
            runId,
            feedbackAttemptId,
            registerId: register.id,
            assetTypeId,
            assetType: entry.name,
            viewedScheduleIds,
        }).catch(forgetSignature)

        function forgetSignature(error) {
            if (capturedSignatures.get(assetTypeId) === signature) capturedSignatures.delete(assetTypeId)
            console.error(error)
        }
    }
}

function toScheduleId(schedule) {
    return uniqueId(schedule.schedule_id)
}
